module.exports = __webpack_public_path__ + "img/comment-filled.4426fea2.svg";